import React from 'react';
import { Popup } from '@progress/kendo-react-popup';
import Icon from '../../../../ui/icon/icon';
import useTranslate from '../../../../../common/hooks/useTranslate';
import { IContextMenyWidget } from '../../../types/IContextMenuWidget';
import { pinWidget } from '../../../../../common/services/http/homeService';
import { parseInt } from 'lodash';
import { useParams } from 'react-router-dom';

const ContextMenuWidget: React.FC<IContextMenyWidget> = ({
                                                           offset,
                                                           show,
                                                           popupClass,
                                                           className,
                                                           animate,
                                                           setGridView,
                                                           gridView,
                                                           excelExport,
                                                           onSVGExportClick,
                                                           onImageExportClick,
                                                           onPDFExportClick,
                                                           widget,
                                                           selectedObject,
                                                         }) => {
  const { t } = useTranslate();

  let { boardId, investorId } = useParams();

  const handlePinWidget = () => {
    const data = {
      contentType: 'analysisContent',
      widgetId: widget.id,
      objectId: selectedObject.objectId,
      objectPath: selectedObject.objectPath,
      nodes: []
    }
    pinWidget(parseInt(investorId), parseInt(boardId), data).then(() => {});
  }

  return (
    <Popup offset={offset} show={show} popupClass={popupClass} className={className} animate={animate}>
      {gridView ? (
        <>
          <div className={'series-click-button pointer'} id={'series-click-button'} onClick={excelExport}>
            {t('CONTEXT_MENU.EXPORT_XLSX')}
            <Icon name={'fa-regular fa-file-excel'} />
          </div>
          {setGridView ? (
            <div className={'series-click-button pointer'} id={'series-click-button'}
                 onClick={() => setGridView(!gridView)}>
              {t('CONTEXT_MENU.TOGGLE_VIEW')} <Icon name={'fa-regular fa-square-sliders-vertical'} />
            </div>
          ) : null}
        </>
      ) : (
        <>
          <div className={'series-click-button pointer'} id={'series-click-button'} onClick={onImageExportClick}>
            {t('CONTEXT_MENU.EXPORT_IMAGE')} <Icon name={'fa-regular fa-file-image'} />
          </div>
          <div className={'series-click-button pointer'} id={'series-click-button'} onClick={onSVGExportClick}>
            {t('CONTEXT_MENU.EXPORT_SVG')}
            <Icon name={'fa-regular fa-file-image'} />
          </div>
          <div className={'series-click-button pointer'} id={'series-click-button'} onClick={onPDFExportClick}>
            {t('CONTEXT_MENU.EXPORT_PDF')} <Icon name={'fa-regular fa-file-pdf'} />
          </div>
          {setGridView ? (
            <div className={'series-click-button pointer'} id={'series-click-button'}
                 onClick={() => setGridView(!gridView)}>
              {t('CONTEXT_MENU.TOGGLE_VIEW')} <Icon name={'fa-regular fa-square-sliders-vertical'} />
            </div>
          ) : null}
        </>
      )}
    </Popup>
  );
};

export default ContextMenuWidget;
